import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const subscribeMailingList = (email) => axios.post(`${API}/mailing-list`, { email });
export const submitEligibility = (data) => axios.post(`${API}/eligibility`, data);
